import { forwardLogout, forwardMaintenance, loadToken, refetchUserInfo } from "src/helpers/auth";
import { getSafely } from "src/helpers/object";
import { forwardNotAllowed } from "src/helpers/role";

import { API_CODES, FORBIDDEN_CODES } from "src/consts/api";
import { ERROR_CODE_INTERNATIONAL_TRANSACTION_RESTRICTED, ERROR_CODE_MONEY_TRANSFER_RESTRICTED } from "src/consts/user";

const UNKNOWN_ERROR_MESSAGE = "unknown error";
const UNVERIFIED_ERROR_MESSAGE = "unverified";

export function getApiHeader() {
  const token = loadToken();
  return {
    Authorization: `Bearer ${token}`,
    pragma: "no-cache",
    "cache-control": "no-cache",
    "content-type": "application/x-www-form-urlencoded"
  };
}

export function isFormData(headers) {
  return headers["content-type"] === "multipart/form-data";
}

export function createResponseInterceptor(response) {
  return response.data;
}

export function createResponseErrorInterceptor(error) {
  const errorResponse = getSafely(["response"], error);
  if (!errorResponse) {
    return Promise.reject([{ message: UNKNOWN_ERROR_MESSAGE }]);
  }

  if (error.response.status === API_CODES.UNAUTHORIZED) {
    forwardLogout(true); // set `comeback` arg to true
  } else if (
    // this condition below is only for sanction flow
    error.response.status === API_CODES.UNPROCESSABLE_CONTENT &&
    [ERROR_CODE_INTERNATIONAL_TRANSACTION_RESTRICTED, ERROR_CODE_MONEY_TRANSFER_RESTRICTED].includes(
      error.response?.data?.errors[0]?.code
    )
  ) {
    refetchUserInfo(error);
  } else if (error.response.status === API_CODES.MAINTENANCE) {
    forwardMaintenance();
  } else if (error.response.status === API_CODES.FORBIDDEN) {
    return handleForbiddenError(error);
  } else if (error.response.status === API_CODES.NOT_FOUND) {
    return Promise.reject([{ message: UNKNOWN_ERROR_MESSAGE }]);
  } else {
    return handleApiResponseError(error);
  }
}

export function handleForbiddenError(error) {
  const forbiddenError = getSafely(["data", "errors"], error.response);

  if (!forbiddenError) {
    forwardNotAllowed();
  } else {
    const forbiddenReason = getSafely(["message"], forbiddenError[0]);

    if (forbiddenReason === FORBIDDEN_CODES.UNVERIFIED) {
      return Promise.reject([{ code: UNVERIFIED_ERROR_MESSAGE }]);
    } else {
      forwardNotAllowed();
    }
  }
}

export function handleApiResponseError(error) {
  let errors = getSafely(["data", "errors"], error.response);
  if (errors) return Promise.reject(errors);

  errors = getSafely(["statusText"], error.response);
  if (errors) return Promise.reject([{ message: errors }]);

  return Promise.reject([{ message: UNKNOWN_ERROR_MESSAGE }]);
}
